import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentSummary from './DocumentSummary';
import DocumentComparison from './DocumentComparison';
import './ProcessingStatus.css'; // Импортируем стили
import useDocumentStore from '../stores/documentStore';

function ProcessingStatus({ documentResult, activeDocumentId, handleDocumentClick }) {
  const { t } = useTranslation();
  const isUploading = useDocumentStore(state => state.isUploading);

  // Если документ загружается, показываем соответствующий статус
  if (isUploading) {
    return (
      <div className="procstatus__container">
        <div className="procstatus__header">
          <div className="procstatus__spinner"></div>
          <div className="procstatus__progress-info">
            <div className="procstatus__progress-bar">
              <div 
                className="procstatus__progress-fill"
                style={{ width: '0%' }}
              ></div>
            </div>
            <p className="procstatus__message">
              {t('processing.uploading')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!documentResult) return null;

  if (documentResult.status === 'error') {
    return (
      <div className="procstatus__error-container">
        <div className="procstatus__error-message">
          {documentResult.error_message}
        </div>
      </div>
    );
  }

  const progress = documentResult.progress || 0;
  const isCompleted = documentResult.status === 'completed';
  const stageMessage = documentResult.stage_message || t('processing.defaultStage');

  const handleDownloadPDF = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/documents/download/${activeDocumentId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `simplified_${documentResult.filename.replace('.docx', '.pdf')}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        const error = await response.json();
        console.error('Error downloading PDF:', error);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const handleDownloadDOCX = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/documents/${activeDocumentId}/download/docx`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `simplified_${documentResult.filename}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        const error = await response.json();
        console.error('Error downloading DOCX:', error);
      }
    } catch (error) {
      console.error('Error downloading DOCX document:', error);
    }
  };
  
  return (
    <>
      <div className="procstatus__container">
        <div className="procstatus__header">
          {isCompleted ? (
            <div className="procstatus__checkmark"></div>
          ) : (
            <div className="procstatus__spinner"></div>
          )}
          <div className="procstatus__progress-info">
            <div className="procstatus__progress-bar">
              <div 
                className={`procstatus__progress-fill ${isCompleted ? 'completed' : ''}`}
                style={{ width: `${progress * 100}%` }}
              ></div>
            </div>
            <p className={`procstatus__message ${isCompleted ? 'completed' : ''}`}>
              {stageMessage.includes('(раздел') ? (
                <>
                  {stageMessage.split('(раздел')[0]}
                  <span className="procstatus__parts-info">
                    (раздел{stageMessage.split('(раздел')[1]}
                  </span>
                </>
              ) : (
                stageMessage
              )}
            </p>
          </div>
          {isCompleted && documentResult.result.length > 0 && (
            <div className="procstatus__download-buttons">
              <button 
                className="procstatus__download-button"
                onClick={handleDownloadPDF}
                title={t('processing.downloadPdfTitle')}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                </svg>
                PDF
              </button>
              <button 
                className="procstatus__download-button docx"
                onClick={handleDownloadDOCX}
                title={t('processing.downloadDocxTitle')}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                </svg>
                DOCX
              </button>
            </div>
          )}
        </div>
        {documentResult.summary && (
          <DocumentSummary summary={documentResult.summary} />
        )}
      </div>

      {documentResult.result.length > 0 && (
        <DocumentComparison documentResult={documentResult} />
      )}
    </>
  );
}

export default ProcessingStatus; 
